import React from "react";
import ReactDOM from "react-dom";
import Routes from "./Routes";
import "./index.css";

const isSpanish = navigator.language.startsWith("es");

if (isSpanish) {
    document.documentElement.lang = "es";

    const meta = document.createElement("meta");
    meta.name = "google";
    meta.content = "notranslate";

    document.head.appendChild(meta);

    document.body.classList.add("notranslate");
}

ReactDOM.render(
    <React.StrictMode>
        <Routes />
    </React.StrictMode>,
    document.getElementById("root")
);
